module.exports = __webpack_public_path__ + "r-v3/img/woman-01.b64d2ca6.png";